import React from "react";
import queryString from "query-string";
import Moment from "react-moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";
import { productoActions } from "../../../_actions";
import { history, LoadingBoton } from "../../../_helpers";
import { NavBarLateral } from "../../includes";
import authService from "../../../_services/cart/authService";
import http from "../../../_services/cart/http.service";
import alertService from "../../../_services/cart/alert.service";
import { alertConfirm } from "./adminUtils";

const esEmail = (valor) => !!valor && valor.includes("@");

/**
 * Quién escribió y cómo responderle.
 *
 * <p>Una consulta puede venir de un usuario logueado (`userFrom`) o de un contacto anónimo
 * (`contacto`, que es un email o un teléfono según lo que haya cargado en el formulario).
 */
const datosContacto = (consulta) => {
  const usuario = consulta.userFrom;
  const contacto = consulta.contacto;

  const email = esEmail(contacto) ? contacto : esEmail(usuario?.username) ? usuario.username : undefined;
  const telefono = (contacto && !esEmail(contacto) ? contacto : undefined) || usuario?.numeroCelular;

  return { usuario, contacto, email, telefono };
};

const antiguedad = (fecha) => {
  const dias = Math.floor((Date.now() - new Date(fecha).getTime()) / 86400000);
  if (dias <= 0) return "hoy";
  return dias === 1 ? "hace 1 día" : `hace ${dias} días`;
};

const textoRespuesta = (consulta) =>
  `Hola! Te escribimos de deautopartes.ar por tu consulta: "${consulta.mensajes[0]?.body ?? ""}".`;

const linkWhatsapp = (telefono, consulta) =>
  `https://api.whatsapp.com/send?phone=${productoActions.normalizarTelefono(telefono)}` +
  `&text=${encodeURIComponent(textoRespuesta(consulta))}`;

const linkEmail = (email, consulta) =>
  `mailto:${email}?subject=${encodeURIComponent("Tu consulta en deautopartes.ar")}` +
  `&body=${encodeURIComponent(textoRespuesta(consulta))}`;

class ConsultaDetail extends React.Component {
  state = {
    consulta: undefined,
    error: undefined,
    alert: undefined,
  };

  componentDidMount() {
    this.cargar();
  }

  cargar = () => {
    const params = queryString.parse(this.props.location.search);

    http.get("/api/admin/consultas/" + params.id).then(
      (data) => this.setState({ consulta: data, error: undefined }),
      (error) => this.setState({ error: "No se pudo cargar la consulta." })
    );
  };

  marcarCompletada = () => {
    const getAlert = alertConfirm(
      "Confirmar",
      `¿Está seguro que desea marcar como completada?`,
      "Sí",
      "No",
      this.cerrarAlert,
      this.enviarCompletada,
      null,
      true
    );
    this.setState({ alert: getAlert });
  };

  cerrarAlert = () => {
    this.setState({ alert: undefined });
  };

  enviarCompletada = () => {
    http.post("/api/admin/consultas/completar", { id: this.state.consulta.id }).then(
      () => {
        alertService.msg("Completada exitosamente!");
        this.cerrarAlert();
        this.cargar();
      },
      (error) => {
        alertService.error(error);
        this.cerrarAlert();
      }
    );
  };

  render() {
    if (!authService.hasAuthority("ADMIN")) {
      history.push("/");
    }

    const { consulta, error } = this.state;
    const contacto = consulta ? datosContacto(consulta) : undefined;

    return (
      <>
        <div className="dashboard">
          <NavBarLateral handleClose={this.cerrarAlert} />
          <div className="dashboard__content">
            {consulta === undefined && error === undefined && (
              <Row>
                <Col>
                  <LoadingBoton grabando={true}></LoadingBoton>
                </Col>
              </Row>
            )}

            {error !== undefined && (
              <Row>
                <Col>{error}</Col>
              </Row>
            )}

            {consulta !== undefined && (
              <>
                <div className="dashboard__content-header">
                  <div className="dashboard__content-title">
                    <h2>Consulta ID {consulta.id}</h2>
                  </div>
                </div>
                <div className="dashboard__content-main">
                  <div className="even-columns">
                    <div>
                      <h4>Datos de la consulta</h4>
                      <div className="dashboard__content-prod-alternative">
                        <div className="dashboard__user-detail">
                          <p>Estado:</p>
                          <span>{consulta.estado}</span>
                        </div>
                        <div className="dashboard__user-detail">
                          <p>Tipo:</p>
                          <span>{consulta.type}</span>
                        </div>
                        <div className="dashboard__user-detail">
                          <p>Recibida:</p>
                          <span>
                            <Moment date={consulta.createdDate} format="DD/MM/YYYY HH:mm" />
                            {" — "}
                            {antiguedad(consulta.createdDate)}
                          </span>
                        </div>
                        {consulta.estado == "PENDIENTE" && (
                          <button className="button" data-type="primary" type="button" onClick={this.marcarCompletada}>
                            Completar
                          </button>
                        )}
                      </div>
                    </div>
                    <div>
                      <h4>Quién consulta</h4>
                      <div className="dashboard__content-prod-alternative">
                        {contacto.usuario && (
                          <div className="dashboard__user-detail">
                            <p>Usuario:</p>
                            <span>
                              <a href={"/admin/userDetail?id=" + contacto.usuario.id}>
                                {contacto.usuario.username}
                              </a>
                            </span>
                          </div>
                        )}
                        {contacto.contacto && (
                          <div className="dashboard__user-detail">
                            <p>Contacto:</p>
                            <span>{contacto.contacto}</span>
                          </div>
                        )}
                        {contacto.telefono && (
                          <button className="button mb-1" type="button" data-type="message">
                            <a target="_blank" rel="noopener noreferrer" href={linkWhatsapp(contacto.telefono, consulta)}>
                              <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg" /> Responder por WhatsApp
                            </a>
                          </button>
                        )}
                        {contacto.email && (
                          <button className="button mb-1" type="button" data-type="message">
                            <a href={linkEmail(contacto.email, consulta)}>
                              <FontAwesomeIcon icon="fa-solid fa-envelope" size="lg" /> Responder por email
                            </a>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4>Mensajes</h4>
                    {consulta.mensajes.map((mensaje) => (
                      <div className="dashboard__content-prod" key={mensaje.id}>
                        {mensaje.createdDate && (
                          <small>
                            <Moment date={mensaje.createdDate} format="DD/MM/YYYY HH:mm" />
                          </small>
                        )}
                        <p style={{ whiteSpace: "pre-wrap", marginBottom: 0 }}>{mensaje.body}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

            {this.state.alert}
          </div>
        </div>
      </>
    );
  }
}

export { ConsultaDetail };
